import {
  BriefcaseBusiness,
  FileCode2,
  FlaskConical,
  House,
  type LucideIcon,
  NotebookPen,
  Palette,
  Wrench,
} from 'lucide-react';

import type { SiteCopy, Text } from '@shaojiang/content';
import type { Tone } from '@shaojiang/theme/preset/recipes/site/tones';

export interface NavItem {
  href: string;
  label: Text;
  icon: LucideIcon;
  /** Storybook paints each icon on its own colored tile */
  tone: Tone;
  /** Also active anywhere under this path (e.g. every /tools/* page) */
  section?: string;
  children?: { href: string; label: string; icon: LucideIcon }[];
}

/** The site's main sections, shared by the top bar and the sidebar. */
export const navItems = (copy: SiteCopy['nav'], tools: SiteCopy['tools']): NavItem[] => [
  { href: '/', label: copy.home, icon: House, tone: 'sky' },
  { href: '/projects', label: copy.projects, icon: BriefcaseBusiness, tone: 'sun' },
  { href: '/articles', label: copy.articles, icon: NotebookPen, tone: 'leaf' },
  { href: '/showcases', label: copy.showcases, icon: FlaskConical, tone: 'blush' },
  {
    href: '/tools/color-picker',
    label: copy.tools,
    icon: Wrench,
    tone: 'cobalt',
    section: '/tools',
    children: [
      { href: '/tools/color-picker', label: tools.colorPicker.title, icon: Palette },
      { href: '/tools/svg2base64', label: tools.svg2base64.title, icon: FileCode2 },
    ],
  },
];

export const isActiveItem = (item: Pick<NavItem, 'href' | 'section'>, path: string) =>
  item.href === '/'
    ? path === '/'
    : path === item.href ||
      path.startsWith(`${item.href}/`) ||
      (!!item.section && path.startsWith(item.section));
